export default function setupPWARedirector() {
  window.onresize = () => {
    const isPWA = navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
    const isHomePage = this.$route.name === 'landing';

    if (isHomePage && isPWA) {
      this.$router.push({ name: 'login' });

      // Removes onresize listener, overwriting it to nothing.
      window.onresize = () => undefined;
    }
  };
}
